import React, { useState } from "react";
import { Button } from "@mui/material";
import { MdAdd } from "react-icons/md";
import MissionAddTaskModal from "../Modal/MissionAddTaskModal";

const AddMissionTask = ({ missionID }) => {

  const [isShow1, setIsShow1] = useState(false);
  const initModal1 = () => setIsShow1(!isShow1);
  return (
    <>
      <div className="d-flex ms-2 m-2">
        <div className="ms-auto">
          <Button variant="contained" color="primary" startIcon={<MdAdd />} onClick={() => initModal1()}>
            Add Task
          </Button>
        </div>
      </div>

      <MissionAddTaskModal
        isShow={isShow1}
        initModal={initModal1}
        missionID={missionID}
      />
    </>
  );
};

export default AddMissionTask;
